import { config } from '@consigli/hooks';
import { createOAuthConfiguration } from '@consigli/oauth';

export const authConfig = createOAuthConfiguration({
  oauthEndpoint: config.OAUTH_ENDPOINT,
  webappClientId: config.WEBAPP_CLIENT_ID,
  webappUrl: config.WEBAPP_URL,
  redirectUri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
});
